<template>
  <div class="guide">
    <div class="container">
      <div class="guide_logo">
        <div class="logo_left f_left">
          <img src="@assets/images/guide_logo.png" />
        </div>
        <div class="logo_right f_right">
          <router-link to="/user">
            <img class="person_img" src="@assets/images/guide_icon1.png" />
          </router-link>

          <a href="https://weibo.com/citynoble">
            <img class="weibo_icon" src="@assets//images/guide_icon2.png" />
          </a>
        </div>
      </div>
      <div class="header">
         <div class="right">
          <div class="xg" @click="$router.push({path:'/category'})"></div>
        </div>
          <router-link :to="'/search'" class="search acea-row row-middle">
            <span class="iconfont icon-xiazai5"></span>搜索商品
          </router-link>
        
       
      </div>
      <div class="areas">
        <div class="areas_left" @click="$router.push({path:'/Index',query:{type:3}})"></div>

        <div class="areas_mid">
          <router-link :to="{path:'/Index',query:{type:1}}">
            <div class="areas_mid1">              
            </div>
          </router-link>
          <router-link :to="{path:'/Index',query:{type:4}}">
            <div class="areas_mid2"></div>
          </router-link>
        </div>
        <div class="areas_right">
          <div class="areas_right1" @click="$router.push({path:'/Index',query:{type:2}})"></div>
          <div class="areas_right2" @click="$router.push({path:'/shops',query:{type:1}})"></div>
        </div>
      </div>
      <div class="slider-banner banner">
        <swiper :options="swiperOption" v-if="banner.length > 0">
          <swiper-slide v-for="(item, index) in banner" :key="index">
            <img :src="item.pic" />
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <div class="join">
        <div class="join_left" @click="$router.push({path:'/zhaos'})"></div>
        <div class="join_right" @click="$router.push({path:'/zhaop'})"></div>
      </div>
      <bottom>
        <div class="bottom_left" @click="$router.push({path:'/promotion'})"></div>
        <div class="bottom_right"  @click="$router.push({path:'/Index',query:{type:5}})"></div>
      </bottom>
      <div class="beian">
        <A href="http://beian.miit.gov.cn/">闽ICP备19022360号-1</A>
      </div>
    </div>
  </div>
</template>
<script>
import "@assets/css/guide.css";

import "@assets/css/swiper.min.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { getHomeData, getShare } from "@api/public";

export default {
  name: "Guide",
  components: {
    swiper,
    swiperSlide
  },
  data: function() {
    return {
      banner: [],
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperRoll: {
        direction: "vertical",
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperScroll: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerView: "auto",
        observer: true,
        observeParents: true
      },
      swiperBoutique: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperProducts: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerView: "auto",
        observer: true,
        observeParents: true
      }
    };
  },
  methods: {
  },
  mounted: function() {
    let that = this;
    var params = { market: 5 };
    sessionStorage.setItem("market", "");
    
    getHomeData(params).then(res => {
      that.$set(that, "banner", res.data.banner);
    });
  }
 
};
</script>